import SideBarCustomer from "./sidebar-customer.container";

export default SideBarCustomer;
